export function isActive(route: string) {
	return this.router.isActive(route, {
		paths: 'subset', queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored'
	});
}
